// Radix popovers fire a harmless "ResizeObserver loop" notice that the CRA dev
// overlay turns into a full-screen error curtain. Silence just that message.
const isNoise = (text) =>
  typeof text === "string" && text.includes("ResizeObserver loop");

window.addEventListener("error", (event) => {
  if (isNoise(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});
